import { readContract, writeContract } from "@wagmi/core";
import { PocketABI } from "../../../Contract/PocketToken_abi";
import { PocketContractAdress } from "../../../Contract/PocketToken_abi";
import { config } from "../../../Provider/config";
import { USDTTestNetABI } from "../../../Contract/PocketToken_abi";
import {
  USDTContractAdress,
  USDCContractAddress,
  USDCTestNetABI,
} from "../../../Contract/PocketToken_abi";
// import { parseEther } from 'ethers/lib/utils.js'; // For ethers version 6
import { waitForTransactionReceipt } from "wagmi/actions";
import { parseEther } from "viem";
export const getTxn = async (hash) => {
  try {
    console.log("thsi si a log ");

    if (!hash) {
      return null;
    }
    const transactionReceipt = await waitForTransactionReceipt(config, {
      hash,
    });

    return transactionReceipt.status === "success" ? true : false;
  } catch (error) {
    console.error("Error getTxn:", error);
    return null;
  }
};
export const getSaleInfo = async () => {
  console.log("This is the Calculator component");
  const result = await readContract(config, {
    abi: PocketABI,
    address: PocketContractAdress,
    functionName: "getSaleInfo",
  });
  console.log("getSaleInfo :", result);
  return result;
};

// export const calculateToken = async (amount, pay) => {
//   const result = await readContract(config, {
//     abi: PocketABI,
//     address: PocketContractAdress,
//     functionName: "calculateToken",
//     args: [amount, pay],
//   });
//   console.log("calculateToken :", result);
//   return result;
// };

export const buy = async (amount, pay) => {
  const result = await writeContract(config, {
    abi: PocketABI,
    address: PocketContractAdress,
    functionName: "buy",
    args: [amount, pay],
  });
  console.log("buy (0xe90bc7b1) :", result);
  return result;
};

export const buyWithETH = async ( pay,amount) => {
  const result = await writeContract(config, {
    abi: PocketABI,
    address: PocketContractAdress,
    functionName: "buyWithETH",
    args: [pay],
    value: parseEther(amount), 

  });
  console.log("buyWithETH (0x94dc9cf3) :", result);
  return result;
};

export const USDTapprove = async (amount) => {
  const result = await writeContract(config, {
    abi: USDTTestNetABI,
    address: USDTContractAdress,
    functionName: "approve",
    args: [PocketContractAdress, amount],
  });
  console.log("approve:", result);
  return result;
};

export const USDCapprove = async (amount) => {
  const result = await writeContract(config, {
    abi: USDCTestNetABI,
    address: USDCContractAddress,
    functionName: "approve",
    args: [PocketContractAdress, amount],
  });
  console.log("approve:", result);
  return result;
};

export const getAprrovingValue = async (amount) => {
  const result = await readContract(config, {
    abi: PocketABI,
    address: PocketContractAdress,
    functionName: "calculateRequiredPayment",
    args: [amount],
  });
  return result;
};
export const GettingETHValue = async (amount) => {
  const result = await readContract(config, {
    abi: PocketABI,
    address: PocketContractAdress,
    functionName: "calculateRequiredETH",
    args: [amount],
  });
  return result;
};
